export const basePositionStyles = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  top: 0,
} as const;
